module.exports = __webpack_public_path__ + "static/img/1005_big.db33f34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1005_big.png
// module id = wbXx
// module chunks = 1